import {
  BoxProps,
  Center,
  Text,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';

import {useTranslate} from '@eksab/i18n';

import {WarningIcon} from '../lineup/icons';

interface PlayerWarningIndicatorProps extends BoxProps {
  player: string;
}

export const PlayerWarningIndicator = ({player, ...props}: PlayerWarningIndicatorProps) => {
  const t = useTranslate();

  return (
    <Popover trigger="click">
      <PopoverTrigger>
        <Center
          width="40%"
          pos="absolute"
          top="0"
          zIndex="popover"
          insetInlineStart="-15%"
          cursor="pointer"
          onClick={(e) => e.stopPropagation()}
          {...props}
        >
          <WarningIcon width="full" height="auto" color="#000" />
        </Center>
      </PopoverTrigger>

      <PopoverContent color="white" borderColor="red.600" bg="red.600" maxW="48" _focus={{}}>
        <PopoverArrow bg="red.600" />

        <PopoverBody textTransform="none" fontSize="xs" fontWeight="500">
          {t('fantasy.lineup.player.warning.invalid-player', {
            player,
            em: (chunks) => (
              <Text as="em" color="inherit" fontWeight="700" fontStyle="normal">
                {chunks}
              </Text>
            ),
          })}
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
